export default __webpack_public_path__ + "static/media/icons8-ssd-100.bac4d95c.svg";